import { useRef } from "react";
import { debounce, justMultiSelcted } from "../utils/index";

export const useEditorMutationObserver = ({
  contextMenuRef,
  setBannerChanged,
  refBannerChanged,
  setLayerChangedOnPause,
}) => {
  let summary = { added: [], removed: [] };
  const send = debounce(() => {}, 200);
  let attributeRecord = [];
  const observerRef = useRef(null);

  const log = (mutations) => {
    for (let mutation of mutations) {
      if (mutation.type === "attributes") {
        let oldValue = mutation.oldValue;
        let newValue = mutation.target.getAttribute(mutation.attributeName);
        oldValue = oldValue.startsWith("[") ? JSON.parse(oldValue) : oldValue;
        newValue = newValue.startsWith("[") ? JSON.parse(newValue) : newValue;

        if (
          JSON.stringify(oldValue) === JSON.stringify(newValue) ||
          (newValue.includes("rgba") && !oldValue.includes("rgba")) ||
          (oldValue.length === 0 && newValue.length !== 0) ||
          justMultiSelcted(oldValue, newValue) === true
        ) {
          setBannerChanged(false);
          refBannerChanged.current = false;
          setLayerChangedOnPause(false);
        } else {
          setBannerChanged(true);
          setLayerChangedOnPause(true);
          refBannerChanged.current = true;
          attributeRecord.push({
            oldValue: oldValue,
            newValue: newValue,
          });
        }
      }

      for (let node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        summary = {
          ...summary,
          added: [summary.added[summary.added.length - 1], node.outerHTML],
        };
      }

      for (let node of mutation.removedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        summary = {
          ...summary,
          removed: [
            summary.removed[summary.removed.length - 1],
            node.outerHTML,
          ],
        };
      }
    }

    send();
  };

  const observeMutations = () => {
    const target = contextMenuRef.current;
    if (!(target instanceof Node)) return;

    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    let observer = new MutationObserver(log);
    observer.observe(target, {
      attributes: true,
      childList: true,
      attributeOldValue: true,
    });
    observerRef.current = observer;
  };

  return { observeMutations };
};

